import { useState } from "react";
import dynamic from "next/dynamic";
import { Options } from "../../SearchBox";

const SearchBox = dynamic(() => import("../../SearchBox"), {
  suspense: true,
});
import useDebounce from "../../../hooks/useDebounce";
import { Response } from "../../../types/Response.interface";
import { useRouter } from "next/router";
import { FaBuilding, FaMapMarkedAlt } from "react-icons/fa";
import { BsFillHouseFill } from "react-icons/bs";
import { Property } from "../../../types/Property.interface";

const MainSearchBox = () => {
  const [option, setOption] = useState<any>();
  const router = useRouter();

  const _onSearch = async (event: HTMLInputElement) => {
    const res: Response = await (
      await import("../../../utils/search")
    ).default(event.value);
    const opt: Options[] = [];

    if (res.ok) {
      const _citites = res.data.cities;
      const _area = res.data.area;
      const _rets = res.data.rets;


      if (_citites.length !== 0) {
        opt.push({
          label: (
            <div className="flex gap-2 justify-center items-center">
              <FaBuilding /> <span>City</span>
            </div>
          ),
          items: _citites?.map((city: any) => ({
            label: city.label,
            value: `/city/${city.slug}`,
          })),
        });
      }

      if (_area.length !== 0) {
        opt.push({
          label: (
            <div className="flex gap-2 justify-center items-center">
              <FaMapMarkedAlt /> <span>Area</span>
            </div>
          ),
          items: _area?.map((area: any) => ({
            label: area.label,
            value: `/area/${area.slug}`,
          })),
        });
      }

      if (_rets.length !== 0) {
        opt.push({
          label: (
            <div className="flex gap-2 justify-center items-center">
              <BsFillHouseFill /> <span>Listing</span>
            </div>
          ),
          items: _rets?.map((prop: Property) => ({
            label: prop.UnparsedAddress?prop.UnparsedAddress:prop.StreetNumber+" "+prop.StreetName+" "+prop.StreetSuffix,
            value: `/propertydetails/${prop.Slug}`,
          })),
        });
      }
    }

    setOption(opt);
  };

  const onSearch = useDebounce(_onSearch, 500);
  return (
    <div className="w-full max-w-[600px]">
      <SearchBox
        onSearch={onSearch}
        options={option}
        onSelect={(e) => {
          router.push(`${e}`);
        }}
        className="z-50"
        placeholder="Search MLS, Address, Area, City etc.."
      />
    </div>
  );
};

export default MainSearchBox;
